var map = {
	"./117.png": "2e4d",
	"./adown-btn.png": "de78",
	"./adownload-btn.png": "5744",
	"./appointment.png": "86aa",
	"./apre-btn.png": "4be3",
	"./bg_1.png": "5ece",
	"./bg_2.png": "1c6e",
	"./bg_3.png": "9f74",
	"./bg_4.png": "9a83",
	"./bg_5.png": "397e",
	"./bg_6.png": "ac0d",
	"./bluestacks-btn.png": "ffc2",
	"./copyright.jpg": "7485",
	"./copyright.png": "519f",
	"./down-btn.png": "8324",
	"./downtips.png": "6a0d",
	"./feature1.jpg": "3b86",
	"./feature2.jpg": "a1c9",
	"./feature3.jpg": "fd6f",
	"./feature4.jpg": "2b34",
	"./feature5.jpg": "960c",
	"./gdown-btn.png": "0951",
	"./gdownload-btn.png": "8c1d",
	"./gpre-btn.png": "7c4f",
	"./hicon-kuang-bai.png": "f120",
	"./hicon-kuang-zi.png": "a261",
	"./hicon1.png": "4d5e",
	"./hicon2.png": "4773",
	"./hicon3.png": "5139",
	"./hicon4.png": "ba11",
	"./hicon5.png": "67df",
	"./hicon6.png": "9db6",
	"./kunyuedown-btn.png": "b474",
	"./l-btn.png": "0c7d",
	"./landscape.png": "cbd2",
	"./lddown-btn.png": "3443",
	"./logo.png": "99bf",
	"./main-bg.jpg": "0248",
	"./menus-open-btn.png": "3bcd",
	"./meuns-close-btn.png": "32d6",
	"./nav-bg.png": "90aa",
	"./newpage-bg.jpg": "17b0",
	"./news-bg.png": "12ec",
	"./news/20110201_01.jpg": "82ad",
	"./news/20110201_02.jpg": "75d4",
	"./news/20110201_03.jpg": "2adb",
	"./news/20110201_04.jpg": "7eca",
	"./news/20110201_05.jpg": "6320",
	"./news/20110201_06.jpg": "6914",
	"./newsList-bg.png": "ca59",
	"./newsTop1.jpg": "e956",
	"./newsTop1.png": "c478",
	"./newsTop2.jpg": "6d3f",
	"./newsTop3.jpg": "34aa",
	"./newsTop4.jpg": "77de",
	"./newsTop5.jpg": "fb5a",
	"./news_facebook_page.png": "17bb",
	"./play-btn.png": "f0ec",
	"./r-btn.png": "0388",
	"./reward1.png": "233a",
	"./reward2.png": "4f35",
	"./reward3.png": "a275",
	"./reward4.png": "eedf",
	"./reward5.png": "041b",
	"./reward_completed.png": "b252",
	"./rinfo1.png": "88f5",
	"./rinfo2.png": "32fb",
	"./rinfo3.png": "e6a1",
	"./rinfo4.png": "a329",
	"./rinfo5.png": "7ae0",
	"./rinfo6.png": "27ae",
	"./role1.png": "9169",
	"./role2.png": "e0fc",
	"./role3.png": "8f0a",
	"./role4.png": "3a66",
	"./role5.png": "2b95",
	"./role6.png": "0c80",
	"./stage-bg.png": "7408",
	"./story_pic_1.png": "f90e",
	"./story_pic_2.png": "0f35",
	"./story_pic_3.png": "a885",
	"./story_pic_4.png": "e33d",
	"./story_pic_5.png": "d8e1",
	"./storyinfo.png": "dc76",
	"./thunder-btn.png": "efff",
	"./title-feature.png": "ff90",
	"./title-heros.png": "6e77",
	"./title-news.png": "aac8",
	"./title-reward.png": "942e",
	"./title-story.png": "3e59",
	"./vplay-bg.png": "d15e",
	"./vplay-btn.png": "441e",
	"./yinghua.png": "6b5e",
	"./世界觀.png": "6f2b",
	"./人物介紹.png": "2555",
	"./新聞.png": "dbdb",
	"./獎勵.png": "1953",
	"./遊戲特色.png": "726e",
	"./首頁.png": "075e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ff8";